import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (username, password) => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  return api.post('/token', formData);
};

export const setupAdmin = (username, password, email) => {
  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);
  formData.append('email', email);
  return api.post('/setup', formData);
};

export const getMe = () => api.get('/users/me');

// Users
export const getUsers = () => api.get('/users');
export const createUser = (user, password) => api.post(`/users?password=${password}`, user);
export const updateUser = (username, userData, password) => {
  let url = `/users/${username}`;
  if (password) url += `?password=${encodeURIComponent(password)}`;
  return api.put(url, userData);
};
export const deleteUser = (username, deleteData) => api.delete(`/users/${username}?delete_data=${deleteData}`);

// Files
export const listFiles = () => api.get('/file/list');
export const deleteFile = (fileId) => api.delete(`/file/${fileId}`);
export const uploadFile = async (file, options = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (options.is_public !== undefined) formData.append('is_public', options.is_public);
  if (options.expires_at) formData.append('expires_at', options.expires_at);
  if (options.shared_with) formData.append('shared_with', options.shared_with);
  
  return api.post('/file/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const downloadFile = (fileId, fileName) => {
  let url = `/file/download/${fileId}`;
  if (fileName) url += `/${encodeURIComponent(fileName)}`;
  return api.get(url, { responseType: 'blob' });
};
export const updateFile = (fileId, options = {}) => {
  const formData = new FormData();
  if (options.is_public !== undefined) formData.append('is_public', options.is_public);
  if (options.expires_at !== undefined) formData.append('expires_at', options.expires_at);
  if (options.shared_with !== undefined) formData.append('shared_with', options.shared_with);
  return api.put(`/file/${fileId}`, formData);
};

// Images
export const listImages = () => api.get('/image/list');
export const deleteImage = (imageId) => api.delete(`/image/${imageId}`);
export const uploadImage = async (file, options = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (options.is_public !== undefined) formData.append('is_public', options.is_public);
  if (options.expires_at) formData.append('expires_at', options.expires_at);
  
  return api.post('/image/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const updateImage = (imageId, options = {}) => {
  const formData = new FormData();
  if (options.is_public !== undefined) formData.append('is_public', options.is_public);
  if (options.expires_at !== undefined) formData.append('expires_at', options.expires_at);
  return api.put(`/image/${imageId}`, formData);
};
export const viewImage = (imageId, imageName) => {
  let url = `/image/view/${imageId}`;
  if (imageName) url += `/${encodeURIComponent(imageName)}`;
  return api.get(url, { responseType: 'blob' });
};

// Pastes
export const listPastes = () => api.get('/paste/list');
export const deletePaste = (pasteId) => api.delete(`/paste/${pasteId}`);
export const createPaste = async (text, options = {}) => {
  const formData = new FormData();
  formData.append('text', text);
  if (options.is_public !== undefined) formData.append('is_public', options.is_public);
  if (options.expires_at) formData.append('expires_at', options.expires_at);
  if (options.burn_after_read !== undefined) formData.append('burn_after_read', options.burn_after_read);
  
  return api.post('/paste', formData);
};
export const getPaste = (pasteId) => api.get(`/paste/${pasteId}`);

// Short URLs
export const listShortUrls = () => api.get('/shorten/list');
export const deleteShortUrl = (shortId) => api.delete(`/shorten/${shortId}`);
export const shortenUrl = (url) => {
  const formData = new FormData();
  formData.append('url', url);
  return api.post('/shorten', formData);
};

// Health
export const checkHealth = () => api.get('/health');
export const getHealthHistory = () => api.get('/health/history');

export const getHealthEvents = (days) => api.get(`/health/events?days=${days}`);
export const createHealthEvent = (event) => api.post('/health/events', event);
export const updateHealthEvent = (id, event) => api.put(`/health/events/${id}`, event);
export const deleteHealthEvent = (id) => api.delete(`/health/events/${id}`);

export const checkSetupRequired = () => api.get('/setup-required');

